import { Component, Injectable, OnInit } from '@angular/core';
import { PeriodoReporte } from 'src/app/model/administrador';
import { Reportes } from 'src/app/model/reporte';
import { frmReporte } from 'src/app/model/formularios';
import {NgbCalendar, NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct, NgbDate} from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment'
import { DatePipe } from '@angular/common';
import { AdministradorService, CatalogosService, ConfiguracionService, ExcelService } from 'src/app/data/service';
import { Roles } from 'src/app/model';
import { Observable } from 'rxjs';
import { UserInfo, UserService } from '../../../../data/service/user.service';

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = '/';
  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day : parseInt(date[2], 10),
        month : parseInt(date[1], 10),
        year : parseInt(date[0], 10)
      };
    }
    return null;
  }
  toModel(date: NgbDateStruct | null): string | null {
    return date ? date.year + this.DELIMITER + date.month + this.DELIMITER + date.day : null;
  }
}

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day : parseInt(date[2], 10),
        month : parseInt(date[1], 10),
        year : parseInt(date[0], 10)
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date ? date.year + this.DELIMITER + date.month + this.DELIMITER + date.day : '';
  }
}

@Component({
  selector: 'app-parametros',
  templateUrl: './parametros.component.html',
  styleUrls: ['./parametros.component.scss'],
   providers: [
    {provide: NgbDateAdapter, useClass: CustomAdapter},
    {provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter}
  ]
})
export class ParametrosComponent implements OnInit {

  public model = new frmReporte;
  public rango = { start: null, end: null };
  public datePipe: DatePipe = new DatePipe('es-MX');

  public esProceso: boolean;
  public ejercicio = null
  public ejercicios = [];

  //Fechas Minimo Maximo
  public mindate = moment().subtract(1, 'years');
  public maxdate = moment();
  public minAnio = 0;
  public minMes = 0;
  public minDia = 0;
  public minAnio2 = 0;
  public minMes2 = 0;
  public minDia2 = 0;
  public maxAnio = 0;
  public maxMes = 0;
  public maxDia = 0;

  public roles = Roles;
  public userInfo$: Observable<UserInfo>;

  constructor(
    private _admin: AdministradorService, 
    private excelService: ExcelService,
    private ngbCalendar: NgbCalendar, 
    private dateAdapter: NgbDateAdapter<string>,
    private catalogosService: CatalogosService,
    private configuracionService: ConfiguracionService,
    private userService: UserService
  ) {
    moment.locale('es');
    this.minAnio = this.mindate.year();
    this.minMes = this.mindate.month() + 1;
    this.minDia = this.mindate.date();
    this.minAnio2 = this.mindate.year();
    this.minMes2 = this.mindate.month() + 1;
    this.minDia2 = this.mindate.date();
    this.maxAnio = this.maxdate.year();
    this.maxMes = this.maxdate.month() + 1;
    this.maxDia = this.maxdate.date();
  }

  ngOnInit() {
    this.userInfo$ = this.userService.userInfo$;

    this.catalogosService.CatalogoEjercicios().subscribe((result: any) => {
      this.ejercicios = result.map(num => ({label: num.toString(), value: num}));
      if(!this.configuracionService.getDatos().ejercicio) {
        this.ejercicio = result[0] ? result[0] : this.maxdate.year();
        this.configuracionService.actualizar({ejercicio: this.ejercicio})
      }   
      else {
        this.ejercicio = this.configuracionService.getDatos().ejercicio;
      }
    });

    if(!this.configuracionService.getDatos().esProcesoElectoral) {
      this.catalogosService.EsProceso().subscribe((result: any) => {
        this.esProceso = result.esProceso;
        this.configuracionService.actualizar({esProcesoElectoral: this.esProceso})
      });
    }
    else {
        this.esProceso = this.configuracionService.getDatos().esProcesoElectoral;
    }
  }

  get today() {
    return this.dateAdapter.toModel(this.ngbCalendar.getToday())!;
  }

  public onSelect(date: NgbDate) {
    let toDate = this.model.fechaFin.split('/');
    let toDateStruct =   {
        day : parseInt(toDate[2], 10),
        month : parseInt(toDate[1], 10),
        year : parseInt(toDate[0], 10)
      };
    if(date.after(toDateStruct))
      this.model.fechaFin = '';
    this.minAnio2 = date.year;
    this.minMes2 = date.month;
    this.minDia2 = date.day;
  }

  public generarReporte() {
    let periodo = new PeriodoReporte();
    periodo.desde = this.model.fechaInicio;
    periodo.hasta = this.model.fechaFin;
     this._admin.obtenerReportes(JSON.stringify(periodo)).subscribe((result: any) => {
      let arreglo = [];
      if(result.length > 0)
        for (let a = 0; a < result.length; a++) {
          let e = result[a];
          let reporte: any = new Reportes();
          reporte.idSolicitud = e.idSolicitud;
          reporte.procesoElectoral = e.esProceso;
          reporte.organo = e.organo;
          reporte.usuarioDiligencia = (e.usuarioDiligencia == null) ? '' : e.usuarioDiligencia + ' ' + e.usuarioDiligenciaPuesto;
          reporte.recepcion = e.recepcion;
          reporte.noPeticion = e.noPeticion;
          reporte.fechaRecepcion = this.datePipe.transform(e.fechaRecepcion, 'dd/MM/yyyy HH:mm');
          reporte.peticionario = e.peticionario;
          reporte.partido = (e.partido == null ? e.unidadResponsable : e.partido);
          reporte.procedimientoSancionador = e.procedimientoSancionador;
          reporte.hechosDenunciados = e.hechosDenunciados;
          reporte.acto = e.acto;

          for (let i = 0; i < e.Ubicaciones.length; i++) {
            let u = e.Ubicaciones[i];
            reporte.ubicacion += 'Calle: ' + u.calle + ', Colonia: ' + (u.colonia == null ? '' : u.colonia) + ', C.P.: ' + (u.cp == null ? '' : u.cp) + ', Municipio: ' + u.municipio + ' | ';
          };

          reporte.cumpleRequisistos = e.cumpleRequisistos;
          reporte.existePrevencion = e.existePrevencion;

          for (let i = 0; i < e.Prevenciones.length; i++) {
            let p = e.Prevenciones[i];
            reporte.prevenciones += p.descripcion + ' | ';
          };

          reporte.fechaPrevencion = this.datePipe.transform(e.fechaPrevencion, 'dd/MM/yyyy HH:mm');
          reporte.fechaRespuesta = this.datePipe.transform(e.fechaRespuesta, 'dd/MM/yyyy HH:mm');
          reporte.atiendePrevencion = e.existeRespuesta;
          reporte.fechaInicioDiligencia = this.datePipe.transform(e.fechaInicioDiligencia, 'dd/MM/yyyy HH:mm');
          reporte.fechaFinDiligencia = this.datePipe.transform(e.fechaFinDiligencia, 'dd/MM/yyyy HH:mm');
          reporte.acta = e.acta;
          reporte.fechaInicioActa = this.datePipe.transform(e.fechaInicioActa, 'dd/MM/yyyy HH:mm');
          reporte.fechaFinActa = this.datePipe.transform(e.fechaFinActa, 'dd/MM/yyyy HH:mm');
          reporte.folios = e.folios;

          for (let i = 0; i < e.Copias.length; i++) {
            let c = e.Copias[i];
            reporte.copiasCertificadas += c.folio + ' | ';
            reporte.fechaExpedida += this.datePipe.transform(c.fechaExpedida, 'dd/MM/yyyy') + ' | ';
            reporte.fechaEntrega += this.datePipe.transform(c.fechaHoraEntrega, 'dd/MM/yyyy HH:mm') + ' | ';
            reporte.fechaDigitalizacion += this.datePipe.transform(c.fechaHoraRegistro, 'dd/MM/yyyy HH:mm') + ' | ';
          };

          reporte.fechaImporcedencia = this.datePipe.transform(e.fechaImporcedencia, 'dd/MM/yyyy HH:mm');

          arreglo.push(reporte);
        };
      this.excelService.exportAsExcelFile(arreglo, 'reporte');
    });
  }

  public btnChangeEstatus(estatus) {
    this._admin.accionCambioProceso(estatus.srcElement.checked).subscribe(r => { })
    this.configuracionService.actualizar({esProcesoElectoral: estatus.srcElement.checked})
  }

  public actualizarEjercicio() {
     this.configuracionService.actualizar({ejercicio: this.ejercicio})
  }

}
